export default __webpack_public_path__ + "6afcae6ab514c3a65aba97ec81d363e1.svg";